import { LOGIN, LOGIN_FAILURE, LOGIN_SUCCESS, FORM_INPUT_CHANGE } from '../Utils/Constants';

export const login = (payload) => {
    return {
        type: LOGIN,
        payload: payload
    }
}

export const loginFailure = (payload) => {
    return {
        type: LOGIN_FAILURE,
        payload: payload
    }
}

export const loginSuccess = (payload) => {
    return {
        type: LOGIN_SUCCESS,
        payload: payload
    }
}

export const formInputChange = (payload) => {
    return {
        type: FORM_INPUT_CHANGE,
        payload: payload
    }
}